let Wait = function (millis = 1000) {
  return new Promise(function (resolve, reject) {
    setTimeout(resolve, millis);
  });
};

module.exports = Wait;